import { Typography } from '@mui/material';
import moment from 'moment';
import React, { FC } from 'react';
import { RemainingTime } from 'shared/components/RemainingTime';
import { useStyles } from './TournamentPendingExpirationNote.styles';

interface ComponentProps {
  maxDuration: number;
  startDate: string;
}

export const TournamentPendingExpirationNote: FC<ComponentProps> = ({ maxDuration, startDate }) => {
  const { classes } = useStyles();

  if (!maxDuration || !startDate) {
    return null;
  }

  const maxDurationInMinutes = Math.round(maxDuration * 24 * 60);
  const expirationDate = moment.utc(startDate).add(maxDurationInMinutes, 'minutes').toISOString();

  return (
    <Typography className={classes.root}>
      Note: this tournament will end in <RemainingTime date={expirationDate} /> unless minimum
      amount of teams is reached.
    </Typography>
  );
};
